var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"view-contact"}},[_c('div',{staticClass:"box"},[_c('p',{staticClass:"title"},[_vm._v("联系我们，让档案管理更高效")]),_c('p',{staticClass:"sub_title"},[_vm._v("提交信息即可免费体验，商务顾问将与您沟通定制解决方案")]),_c('el-button',{staticClass:"trial-button",attrs:{"type":"primary","round":""},on:{"click":_vm.openTrialDialog}},[_vm._v(" 马上预约体验 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }